import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ContractsListPage } from './contracts-list';
import { UserHeaderComponentModule } from '../../components/header/header.module';

@NgModule({
  declarations: [
    ContractsListPage,
  ],
  imports: [
    IonicPageModule.forChild(ContractsListPage),
    UserHeaderComponentModule
  ],
})
export class ContractsListPageModule {}



// WEBPACK FOOTER //
// ./src/pages/contracts-list/contracts-list.module.ts